import { Factory } from '../Factory';

namespace app.services.storage {

  export enum ForensicImageType {
    Cellebrite = "cellebrite",
    Oxygen = "oxygen",
    Axiom = "axiom",
    Paraben = "paraben"
  }

  export class SFTPService {
    private configService;
    private httpService;
    private notificationService;

    constructor(configService, httpService, notificationService) {
      this.configService = configService;
      this.httpService = httpService;
      this.notificationService = notificationService;
    }

    public GetUploadsListing(project, baseDir, imageType: ForensicImageType) {
      const url = `${this.configService.getServerBaseUrl()}/project/${project.id}/sftp`;
      const params = {};

      return this.httpService.$http({
        method: "POST",
        url,
        data: {
          baseDir,
          forensicImageType: imageType
        }
      });
    }
  }

  frontendApp.factory("SFTPService", ["ConfigService", "HttpService", "NotificationService", Factory.Create(SFTPService)]);
}
